export default {"src":"/_next/static/media/business_case.5a1a472d.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};